import { render, staticRenderFns } from "./pageination.vue?vue&type=template&id=6979a4ae&scoped=true&"
import script from "./pageination.vue?vue&type=script&lang=js&"
export * from "./pageination.vue?vue&type=script&lang=js&"
import style0 from "./pageination.vue?vue&type=style&index=0&id=6979a4ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6979a4ae",
  null
  
)

export default component.exports